import PgaCoachJourney from './pga-coach-journey'
import { COACH_JOURNEY_QUERY } from './coach-persona.query'

export default PgaCoachJourney
export { COACH_JOURNEY_QUERY }
